export default {"src":"/_next/static/media/twitter.ab54e734.svg","height":32,"width":31};